import React, { useState, useContext } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { PaginationContext } from "../../constants/context/PaginationProvider";
import "./user.css";

const UserLog = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const navigate = useNavigate();
  const location = useLocation();

  const { globalSearchString } = useContext(PaginationContext);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const rawLogs = location.state?.designationLogs || [];

  const processedLogs = rawLogs.map((log, index) => {
    let toDateStr = null;
    if (index < rawLogs.length - 1) {
      const nextDate = new Date(rawLogs[index + 1].date);
      nextDate.setDate(nextDate.getDate() - 1);

      const fromDateObj = new Date(log.date);
      if (nextDate < fromDateObj) {
        toDateStr = fromDateObj.toISOString();
      } else {
        toDateStr = nextDate.toISOString();
      }
    } else {
      toDateStr = new Date().toISOString();
    }

    return {
      ...log,
      toDate: toDateStr,
    };
  });

  const logs = processedLogs.filter((log) => {
    let matchesSearch = true;
    if (globalSearchString) {
      matchesSearch = (log.designation || "").toLowerCase().includes(globalSearchString.toLowerCase());
    }

    const logDate = log.date ? new Date(log.date) : null;
    if (logDate) {
      logDate.setHours(0, 0, 0, 0);
    }

    let matchesFrom = true;
    if (fromDate && logDate) {
      const from = new Date(fromDate);
      from.setHours(0, 0, 0, 0);
      matchesFrom = logDate >= from;
    }

    let matchesTo = true;
    if (toDate && logDate) {
      const to = new Date(toDate);
      to.setHours(0, 0, 0, 0);
      matchesTo = logDate <= to;
    }

    return matchesSearch && matchesFrom && matchesTo;
  });

  return (
    <div className="userLogPageWrapper">
      <div className="userLogContentBox">
        {/* SVG Watermark */}
        <svg className="userLogWatermark" viewBox="0 0 1026 1026" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.05">
            <circle cx="513" cy="513" r="513" fill="#2F3293" />
            <path
              d="M804.136 429.808C804.136 352.587 773.46 278.528 718.857 223.925C664.253 169.321 590.195 138.646 512.974 138.646C435.753 138.646 361.695 169.321 307.091 223.925C252.488 278.528 221.812 352.587 221.812 429.808L512.974 429.808H804.136Z"
              fill="white"
            />
            <path
              d="M381.219 553.277V673.535H359.354V619.988H312.5V626.905C312.5 637.391 307.145 641.853 300.452 641.853C287.957 641.853 271.67 624.004 271.67 611.956C271.67 606.155 275.24 601.47 286.173 601.47H290.635V553.277H263.415V534.759H403.53V553.277H381.219ZM359.354 553.277H312.5V601.47H359.354V553.277ZM464.943 484.112C460.035 512.894 444.417 522.934 421.436 522.934C398.233 522.934 382.615 512.894 377.706 484.112L396.448 479.204C399.794 499.061 407.603 505.754 421.436 505.754C435.046 505.754 442.855 499.061 446.202 479.204L464.943 484.112ZM441.517 553.277V673.535H419.651V553.277H400.464V534.759H463.828V553.277H441.517ZM596.48 534.759V553.277H574.392V673.535H552.304V636.945C544.495 642.299 534.678 645.646 521.515 645.646C491.617 645.646 474.661 628.466 466.852 593.661C489.386 589.645 498.757 583.398 498.757 572.019C498.757 564.879 495.41 558.409 490.056 553.277H460.382V534.759H596.48ZM493.179 605.932C498.088 619.765 506.12 627.128 521.515 627.128C534.678 627.128 544.718 620.434 552.304 612.179V553.277H513.036C517.945 559.971 520.399 567.334 520.399 574.696C520.399 590.314 511.698 599.908 493.179 605.932ZM593.291 553.277V534.759H751.701V553.277H729.389V673.535H707.524V596.561C706.855 596.561 706.186 596.561 705.516 596.561C691.237 596.561 681.643 605.932 677.404 631.59L655.985 625.789C657.101 616.865 659.332 609.279 662.679 602.808C658.216 599.016 652.639 596.561 645.499 596.561C632.335 596.561 624.526 605.04 624.526 617.98C624.526 633.598 635.905 645.869 662.679 660.818L650.408 677.328C620.734 660.818 602.661 641.853 602.661 615.972C602.661 590.76 619.172 577.82 642.599 577.82C655.539 577.82 665.356 582.059 673.165 588.975C681.197 581.836 691.906 578.266 705.07 578.266C705.739 578.266 706.632 578.266 707.524 578.489V553.277H593.291Z"
              fill="white"
            />
            <path
              d="M289.089 771.228L277.487 876.761H258.523L277.487 712.773L339.959 825.891L402.43 712.773L421.395 876.761H402.43L390.828 771.228L339.959 862.258L289.089 771.228ZM459.228 798.671C459.228 810.422 461.757 820.908 466.814 830.13C472.02 839.352 479.085 846.641 488.01 851.995C496.934 857.35 507.049 860.027 518.353 860.027C529.806 860.027 539.921 857.35 548.696 851.995C557.621 846.641 564.612 839.352 569.669 830.13C574.875 820.908 577.478 810.422 577.478 798.671C577.478 786.921 574.875 776.434 569.669 767.212C564.612 757.99 557.621 750.702 548.696 745.347C539.921 739.993 529.806 737.315 518.353 737.315C507.049 737.315 496.934 739.993 488.01 745.347C479.085 750.702 472.02 757.99 466.814 767.212C461.757 776.434 459.228 798.671 439.148 798.671ZM439.148 798.671C439.148 787.218 441.082 776.658 444.949 766.989C448.965 757.172 454.543 748.694 461.682 741.554C468.822 734.266 477.226 728.614 486.894 724.598C496.562 720.433 507.049 718.351 518.353 718.351C529.806 718.351 540.292 720.433 549.812 724.598C559.48 728.614 567.884 734.266 575.024 741.554C582.163 748.694 587.667 757.172 591.534 766.989C595.55 776.658 597.558 787.218 597.558 798.671ZM624.34 720.582H643.305V876.761H624.34V720.582ZM679.029 720.582H697.994V858.912H759.35V876.761H679.029V720.582Z"
              fill="white"
            />
          </g>
        </svg>

        {/* Header */}
        <div className="userLogHeaderWrapper">
          <h2 className="userLogHeaderTitle">View Log</h2>
          <button type="button" className="userLogCloseBtnTop" onClick={() => navigate(-1)}>
            Close
          </button>
        </div>

        {/* Ultra-Compact Inline Filter Bar */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "16px",
            padding: "10px 24px",
            backgroundColor: "#ffffff",
            borderBottom: "1px solid #e2e8f0",
            boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
          }}
        >
          {/* Inline From Date Field */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#475569" }}>From:</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              style={{
                padding: "6px 10px",
                border: "1px solid #cbd5e1",
                borderRadius: "6px",
                outline: "none",
                fontSize: "14px",
                color: "#334155",
                cursor: "pointer",
                backgroundColor: "#f8fafc",
                fontFamily: "inherit",
                width: "140px",
                transition: "all 0.15s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#2F3293";
                e.target.style.backgroundColor = "#ffffff";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#cbd5e1";
                e.target.style.backgroundColor = "#f8fafc";
              }}
            />
          </div>

          {/* Inline To Date Field */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#475569" }}>To:</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              style={{
                padding: "6px 10px",
                border: "1px solid #cbd5e1",
                borderRadius: "6px",
                outline: "none",
                fontSize: "14px",
                color: "#334155",
                cursor: "pointer",
                backgroundColor: "#f8fafc",
                fontFamily: "inherit",
                width: "140px",
                transition: "all 0.15s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#2F3293";
                e.target.style.backgroundColor = "#ffffff";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#cbd5e1";
                e.target.style.backgroundColor = "#f8fafc";
              }}
            />
          </div>

          {/* Inline Tiny Clear Button */}
          {(fromDate || toDate) && (
            <button
              onClick={() => {
                setFromDate("");
                setToDate("");
              }}
              style={{
                padding: "6px 12px",
                backgroundColor: "#fee2e2",
                color: "#dc2626",
                border: "none",
                borderRadius: "6px",
                fontSize: "13px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#fca5a5")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#fee2e2")}
            >
              Clear
            </button>
          )}
        </div>

        {/* Timeline Section */}
        <div className="timelineWrapper">
          <div className="timelineLine"></div>

          {logs.length > 0 ? (
            logs.map((log, index) => (
              <div className="timelineItem" key={index}>
                <div className="timelineDot"></div>
                <div className="timelineContent">
                  <div className="timelineSection timelineCol1">
                    <span className="timelineLabel">Designation : </span>
                    <span className="timelineDesignationBadge">{log.designation || "--"}</span>
                  </div>

                  <div className="timelineSection timelineCol2">
                    <span className="timelineText">From : {log.date ? new Date(log.date).toLocaleDateString("en-GB").replace(/\//g, "-") : "--"}</span>
                    <span className="timelineDivider">/</span>
                    <span className="timelineText">To : {log.toDate ? new Date(log.toDate).toLocaleDateString("en-GB").replace(/\//g, "-") : "--"}</span>
                  </div>

                  {/* <div className="timelineSection timelineCol3">
                    <span className="timelineText">Shift : --</span>
                  </div> */}
                </div>
              </div>
            ))
          ) : (
            <div style={{ textAlign: "center", padding: "40px", color: "#6b7280" }}>No designation logs found for this user.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserLog;
